/**
 * For non-declarative behavior of routes
 */
import { RouterState, LocationDescriptor } from 'lib/ReactRouterTypes';

export function goToClassCode(
  nextState: RouterState,
  replaceWith: (location: LocationDescriptor) => void
) {
  replaceWith(`/classes/${nextState.params.groupCode}`);
}
